import { doodModalConfig } from './dood-modal-config';
import { propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const KIOSKPRODUCTOVERVIEWMODAL_LEGACY_FIELD_ORDER = [
  { type: 'messageUtil', options: {"type":"info","message":"Handle: kiosk-add-product-overview-modal"} },
  { type: 'groupedFields', handle: 'colors', fields: ["background","accent","closeButton"] }
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  kioskProductOverviewModalDescriptor: _generatedKioskProductOverviewModalDescriptor,
  kioskProductOverviewModalModalDefinition,
  kioskProductOverviewModalDashboardLayout,
  kioskProductOverviewModalConfig,
  kioskProductOverviewModalResolveConfig,
  kioskProductOverviewModalProperties,
} = doodModalConfig(
  {
    name: "Kiosk Product Overview Modal",
    handle: "kiosk-add-product-overview-modal",
    internal_name: "KioskProductOverviewModal",
    componentType: 'KioskProductOverviewModalComponent',
    category: 'modal',
    description: "Kiosk Product Overview Modal.",
    keywords: [],
    isContentModal: true,
    defaultHandle: "kiosk-add-product-overview-modal",
    sharedFields: {}
  },

  () => ({
    colors: {
      background: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Background Color",
          "help": "The default background color is inferred from the page that open the modal."
        }
      }),
      accent: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Accent Color",
          "help": "The default accent color is inferred from the page that open the modal."
        }
      }),
      closeButton: propertyValue({
        type: 'color',
        value: { type: 'default', value: '' },
        options: {
          "label": "Close Button Color",
          "help": "The default close button color is inferred from the background color."
        }
      })
    }
  }),

  () => ({
    tabs: [
      {
        label: 'Design',
        fieldsets: [
          {
            legend: 'Properties',
            fields: ["colors.background", "colors.accent", "colors.closeButton"],
          },
        ],
      },
    ],
  })
);

export function kioskProductOverviewModalDescriptor(): IBlockDescriptor;
export function kioskProductOverviewModalDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function kioskProductOverviewModalDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedKioskProductOverviewModalDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedKioskProductOverviewModalDescriptor, kioskProductOverviewModalProperties, fieldOrder);
}

export {
  kioskProductOverviewModalModalDefinition,
  kioskProductOverviewModalDashboardLayout,
  kioskProductOverviewModalProperties,
  kioskProductOverviewModalConfig,
  kioskProductOverviewModalResolveConfig,
};

export type KioskProductOverviewModalConfig = typeof kioskProductOverviewModalConfig;
